import {OrderBase} from "app/orders/models/order-base";
export class GetSlickGridProp {
    constructor(public columns: Slick.Column<OrderBase>[], public tableName: string, public tableIndex?: number) {
        if (tableIndex === undefined) this.tableIndex = 0;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/models/get-slick-grid-prop.ts